import { Component, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'no-preferred-writers-modal',
  template: `
    <modal (outsideClick)="onClose()">
      <h4 class="text-green">Uh-oh</h4>
      <p class="h4-subheader">No preferred writers</p>
      <hr class="brand-hr" />
      <p>
        It looks like you don't have any preferred writers yet. Here's a link to
        get you started:
      </p>
      <div class="row">
        <div class="col-12">
          <a
            target="_blank"
            href="https://help.verblio.com/my-account/making-requests/topic-ideas-proposed-topics-from-preferred-writers">
            How to Get Topics From Preferred Writers
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button
            type="button"
            class="float-right btn btn-default"
            (click)="onClose()">
            Got it!
          </button>
        </div>
      </div>
    </modal>
  `,
})
export class NoPreferredWritersModal {
  @Output() close: EventEmitter<null> = new EventEmitter<null>()

  onClose(): void {
    this.close.emit()
  }
}
